/**
 * The registry of workflow elements: exactly one per action and one per flow-control step kind, keyed by type.
 * The `Record` key type makes a missing element a compile error; the validator reads action inputs from here, so an element field is what a save accepts.
 */
import { WorkflowActionType, WorkflowStepType } from './workflow.definition';
import { WorkflowElement, WorkflowElementType } from './workflow.element';
import { FOR_EACH_ELEMENT } from './workflow.elements/for.each.element';
import { IF_ELEMENT } from './workflow.elements/if.element';
import { SET_VARIABLE_ELEMENT } from './workflow.elements/set.variable.element';
import { ADD_JOB_NOTE_ELEMENT } from './workflow.elements/job.note.add.element';
import { SEND_JOB_EMAIL_ELEMENT } from './workflow.elements/job.email.send.element';
import { SEND_JOB_SMS_ELEMENT } from './workflow.elements/job.sms.send.element';
import { COMPLETE_JOB_STAGE_ELEMENT } from './workflow.elements/job.stage.complete.element';
import { CREATE_JOB_STAGE_ELEMENT } from './workflow.elements/job.stage.create.element';
import { LIST_JOB_STAGES_ELEMENT } from './workflow.elements/job.stages.list.element';
import { UPDATE_JOB_ELEMENT } from './workflow.elements/job.update.element';
import { STOP_ELEMENT } from './workflow.elements/stop.element';
import { SWITCH_ELEMENT } from './workflow.elements/switch.element';
import { WAIT_ELEMENT } from './workflow.elements/wait.element';

/** Every workflow element by type; read by the validator (action inputs) and the editor (picker, node, step panel). */
export const WORKFLOW_ELEMENTS: Record<WorkflowElementType, WorkflowElement> = {
    [WorkflowStepType.If]: IF_ELEMENT,
    [WorkflowStepType.Switch]: SWITCH_ELEMENT,
    [WorkflowStepType.ForEach]: FOR_EACH_ELEMENT,
    [WorkflowStepType.Wait]: WAIT_ELEMENT,
    [WorkflowStepType.Stop]: STOP_ELEMENT,
    [WorkflowStepType.SetVariable]: SET_VARIABLE_ELEMENT,
    [WorkflowActionType.AddJobNote]: ADD_JOB_NOTE_ELEMENT,
    [WorkflowActionType.SendJobEmail]: SEND_JOB_EMAIL_ELEMENT,
    [WorkflowActionType.SendJobSms]: SEND_JOB_SMS_ELEMENT,
    [WorkflowActionType.ListJobStages]: LIST_JOB_STAGES_ELEMENT,
    [WorkflowActionType.CompleteJobStage]: COMPLETE_JOB_STAGE_ELEMENT,
    [WorkflowActionType.CreateJobStage]: CREATE_JOB_STAGE_ELEMENT,
    [WorkflowActionType.UpdateJob]: UPDATE_JOB_ELEMENT,
};
